// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"804":"app-oficina","966":"app-chofer"}[chunkId] || chunkId) + "." + {"239":"5c4b3bbb","261":"461a4ac1","395":"80ac0ed4","455":"d2a825c6","804":"2f6af0c3","939":"807a590a","966":"7a5b0def","977":"e30e0df5"}[chunkId] + ".chunk.js";
};